module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-1@3x.ab399b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-1@3x.png
// module id = dZPy
// module chunks = 18